import ShowToast from 'actions/toast/show_toast';
import { ToastType } from 'models/toast';

export default class ShowSnippetSuccessToast {
  constructor(context) {
    this.context = context;
  }

  run(snippet) {
    this.context.executeAction(ShowToast, {
      type: ToastType.SUCCESS,
      message: `"${snippet.name}" has been saved. Click here to view.`,
      link: `/kb-admin/answer/${snippet.id}`,
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/knowledge_base/show_snippet_success_toast.js